import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
  IconButton,
  Chip,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import { TableContent, HeaderAccordion } from "../styles/Fornecedor";
import TableDefault from "../../../../components/grid/TableDefault";
import { FornecedorContext } from "../contexts/FornecedorContext";
import useFornecedorController from "../controllers/FornecedorController";
import ModalFornecedorBanco from "./ModalFornecedorBanco";
import { IconButtonStyled } from "../styles/Fornecedor";

import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import { DeleteOutlined } from "@material-ui/icons";

export default function AccordionFonecedorBanco() {
  const {
    //Contato
    expanded,
    bank,
    listBank,
    setBank,
    geralErrors,
  } = useContext(FornecedorContext);
  const {
    handleChangeOpenAcordion,
    handleRemoveItemTable,
    handleEditItemTable,
  } = useFornecedorController();
  const [open, setOpen] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);

  const { handleDeleteSupplierBankAcoount } = useFornecedorController();

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        return (
          <SpeedDialErp
            actions={[
              {
                icon: <EditOutlinedIcon />,
                name: "Editar",
                action: () => {
                  setRowEdit(item);
                  setOpen(true);
                },
              },
              {
                icon: <DeleteOutlined />,
                name: "Excluir",
                action: () => handleDeleteSupplierBankAcoount(item),
              },
            ]}
          />
        );
      },
    },
    {
      id: "conta_padrao_flag",
      label: "Principal",
    },
    {
      format: (item) => {
        const bank = listBank.find((opt) => opt.codigo === item.codigo_banco);
        return bank?.nome;
      },
      label: "Banco",
    },
    {
      id: "agencia",
      label: "Agência",
    },
    {
      id: "conta",
      label: "Conta",
    },
    {
      id: "chave_pix",
      label: "Chavel PIX",
    },
    {
      id: "tipo_pix",
      label: "Tipo",
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        setLoadingTable(false);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingTable(false);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const newList = [];
      bank.forEach(
        (item, index) =>
          (newList[index] = {
            ...item,
            acoes: (
              <div>
                <Tooltip title="Editar">
                  <IconButton>
                    <EditOutlinedIcon
                      onClick={() =>
                        handleEditItemTable(setOpen, setRowEdit, item, index)
                      }
                    />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Deletar">
                  <IconButton>
                    <DeleteOutlineOutlinedIcon
                      onClick={() =>
                        handleRemoveItemTable(
                          setBank,
                          setDataTable,
                          bank,
                          index
                        )
                      }
                    />
                  </IconButton>
                </Tooltip>
              </div>
            ),
            conta_padrao_flag: item.conta_padrao ? (
              <div>
                <Tooltip title="Editar">
                  <CheckIcon></CheckIcon>
                </Tooltip>
              </div>
            ) : (
              <></>
            ),
          })
      );
      setDataTable(newList);
    })();
    // eslint-disable-next-line
  }, [bank]);

  return (
    <>
      <ModalFornecedorBanco
        open={open}
        setOpen={setOpen}
        setRowEdit={setRowEdit}
        rowEdit={rowEdit}
      />
      <Grid item>
        <Accordion
          expanded={expanded.bank || false}
          onChange={() => handleChangeOpenAcordion("bank")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs>
                  <Chip
                    bgcolor={
                      !expanded.general &&
                      geralErrors.accordions &&
                      geralErrors.accordions.includes("bank")
                        ? "red"
                        : "primary"
                    }
                    textcolor="white"
                    label="INFORMAÇÕES FINANCEIRAS"
                  />
                </Grid>
                <Grid item flex={1}>
                  <Tooltip title="Adicionar Dados Bancários">
                    <IconButtonStyled onClick={() => setOpen(true)}>
                      <AddIcon />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        loading={loadingTable}
                        columns={columns}
                        values={dataTable}
                        tableTitle=""
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
